import { Box, Typography } from '@mui/material'
import MuiPhoneNumber, { MuiPhoneNumberProps } from 'material-ui-phone-number'
import { selectLocale } from 'modules/locale/slice'
import React, { FC } from 'react'
import 'react-phone-number-input/style.css'
import { useSelector } from 'react-redux'

type Props = MuiPhoneNumberProps & {
  labelColor?: string | 'primary' | 'secondary',
  labelWeight?: number | 'normal',
  labelVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption',
  fullWidth?: boolean,
}

export const PhoneField: FC<Props> = ({ label, labelWeight, labelVariant, labelColor, ...props }) => {
  const { locale } = useSelector(selectLocale)

  return (
    <Box width={props.fullWidth ? '100%' : 'auto'} height='auto'>
      <Typography
        hidden={!label}
        mb='5px'
        color={labelColor || 'secondary'}
        variant={labelVariant ?? 'body2'}
        fontWeight={labelWeight}
      >
        {label}
      </Typography>
      <MuiPhoneNumber
        label=''
        {...props}
        placeholder={props.placeholder ?? label as string}
        defaultCountry={locale.slice(0, 2)}
        countryCodeEditable={false}
      />
    </Box>
  )
}
